import {
  createOvertimeRequestApi,
  getAllOvertimeRequestsApi,
  updateOvertimeStatusApi,
  updateOvertimeRequestApi, 
  deleteOvertimeRequestApi
} from "../../api/overtime";
import { toast } from "react-toastify";


export const createOvertimeRequest = (requestData) => async (dispatch, getState) => {
    const token = getState().user?.user?.token;
    if (!token) {
        toast.error("Authentication error. Please log in again.");
        return Promise.reject("Authentication error");
    }

    try {
        const { data } = await createOvertimeRequestApi(requestData, token);
        if (data.succeeded) {
            toast.success(data.message); 
            return Promise.resolve(data.data);
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        const message = error.response?.data?.message || "Failed to submit overtime request.";
        toast.error(message);
        return Promise.reject(error);
    }
};

export const getAllOvertimeRequests = (filters) => async (dispatch, getState) => {
    const token = getState().user?.user?.token;
    try {
        const { data } = await getAllOvertimeRequestsApi(filters, token);
        if (data.succeeded) {
            return data;
        }
    } catch (error) {
    }
};

export const approveOrRejectOvertime = (id, statusData) => async (dispatch, getState) => {
    const token = getState().user?.user?.token;
    try {
        const { data } = await updateOvertimeStatusApi(id, statusData, token);
        if (data.succeeded) {
            toast.success(data.message);
            return Promise.resolve();
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        const message = error.response?.data?.message || error.message || "Action failed.";
        toast.error(message);
        return Promise.reject(message);
    }
};

export const updateOvertimeRequest = (id, requestData) => async (dispatch, getState) => {
    const token = getState().user?.user?.token;
    try {
        const { data } = await updateOvertimeRequestApi(id, requestData, token);
        if (data.succeeded) {
            toast.success("Overtime request updated successfully!");
            return Promise.resolve();
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        const message = error.response?.data?.message || "Failed to update overtime request.";
        toast.error(message);
        return Promise.reject(error);
    }
};

export const deleteOvertimeRequest = (id) => async (dispatch, getState) => {
    const token = getState().user?.user?.token;
    try {
        const { data } = await deleteOvertimeRequestApi(id, token);
        if (data.succeeded) {
            toast.success("Overtime request deleted successfully!");
            return Promise.resolve();
        } else {
            throw new Error(data.message);
        }
    } catch (error) {
        const message = error.response?.data?.message || "Failed to delete request.";
        toast.error(message);
        return Promise.reject(error);
    }
};